import { createSelector } from '@ngrx/store';
import { SecurityEventsFeature } from './security-events.reducer';
import { EInitEventStateCode } from 'ngx-mt-ui-lib/api-client';

const {
  selectId,
  selectItem,
  selectForm,
  selectHasChanges,
  selectProtocolDirty,
  selectProtocolSaving,
  selectLoading,
  selectStateListWithCount,
  selectTags,
  selectChildEventList,
} = SecurityEventsFeature;

export const selectSecurityEventsLoading = selectLoading;
export const selectSecurityEventsId = selectId;
export const selectSecurityEventsItem = selectItem;
export const selectSecurityEventsForm = selectForm;
export const selectSecurityEventsOwnerHasChanges = selectHasChanges;
export const selectSecurityEventsProtocolSaving = selectProtocolSaving;
export const selectSecurityEventsHasChanges = createSelector(
  selectHasChanges,
  selectProtocolDirty,
  selectProtocolSaving,
  (ownerDirty, protocolDirty, protocolSaving) =>
    ownerDirty || protocolDirty || protocolSaving,
);
export const selectSecurityEventsStateListWithCount = selectStateListWithCount;
export const selectSecurityEventTags = selectTags;
export const selectSecurityEventsChildEventList = selectChildEventList;

//#region Functions
export const selectCanEditSecurityEventInNew = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.NEW,
);
export const selectCanEditSecurityEventInWorking = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.WORKING,
);
export const selectCanEditSecurityEventInCompleted = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.COMPLETED,
);
export const selectSecurityEventCanAddParentSecurityEvent = createSelector(
  selectItem,
  (item) => !item?.parentId,
);
export const selectCanDeleteSecurityEventChildEvent = createSelector(
  selectItem,
  (item) =>
    item?.initEventStateCode === EInitEventStateCode.COMPLETED ||
    item?.initEventStateCode === EInitEventStateCode.CLOSE,
);
export const selectCanSetSecurityEventToWorking = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.NEW,
);
export const selectCanSetSecurityEventToCancel = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.NEW,
);
export const selectCanSetSecurityEventToCompleted = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.WORKING,
);
export const selectCanSetSecurityEventToClose = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.COMPLETED,
);
export const selectCanSetSecurityEventToArchive = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.CLOSE,
);
export const selectCanSecurityEventReopen = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.CLOSE,
);
export const selectSecurityEventCanShowArchivedDate = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.ARCHIVE,
);
export const selectSecurityEventCanShowCanceledDate = createSelector(
  selectItem,
  (item) => item?.initEventStateCode === EInitEventStateCode.CANCEL,
);
export const selectSecurityEventCanShowCompletedDate = createSelector(
  selectItem,
  (item) => !!item?.completeDate,
);
//#endregion
